export default __webpack_public_path__ + "static/media/ppi-simplified.cae8a5dd.svg";